import styled from 'styled-components';

interface CodeItemProps {
  variant: 'circle' | 'square';
}

export const ItemInputContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--spacing-small);
`;

export const CodeItem = styled.input<CodeItemProps>`
    width: 85px;
    height: 85px;
    font-size: 24px;
    text-align: center;
    line-height: 50px;
    border-radius: ${({ variant }) => (variant === 'circle' ? '50%' : '0px')};
    border: 1px solid var(--colorBorderBase);
    background-color: white;
    outline: none;

    // Remove spinner dos inputs numéricos
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    // Firefox
    &[type=number] {
        -moz-appearance: textfield;
    }

    @media (max-width: 768px) {    width: 35px;    height: 55px;}
`;

export const SendTextData = styled.div`
    font-size: var(--font-medium);
    color: var(--color-neutral-dark-lighter);
    margin-top: var(--spacing-regular);
    margin-bottom: var(--spacing-extra-big);
`;

export const ItemWrapper = styled.div`
    margin-bottom: var(--spacing-regular);
    margin-top: var(--spacing-regular);
`;
